import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import BergenCredentialsStore from "../../../stores/credentials/bergen-credentials-store";
import { IOption, SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";

interface IIntegrationProps {
    credentialsStore: BergenCredentialsStore,
    vGroup: IValidationGroup,
}

const BergenCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    const warehouseOptionsList: IOption[] = credentialsStore.getWarehouseOptionsList();
    const selectedWarehouse: IOption | undefined = warehouseOptionsList.find(warehouse => warehouse.value === credentialsStore.warehouse);
    const onWarehouseSelect = (warehouse: IOption) => {
        credentialsStore.warehouse = warehouse.value as string;
    };

    return (
        <>
            <FormFieldLine label='Username' required key='username' note='Bergen logistics'>
                <Input
                    value={credentialsStore.username}
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Password' required key='password' note='Bergen Logistics password'>
                <Input
                    value={credentialsStore.password}
                    onChange={v => credentialsStore.password = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Web Address' required key='web_address' note='Your web address given by Bergen Logistics'>
                <Input
                    value={credentialsStore.web_address}
                    onChange={v => credentialsStore.web_address = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Warehouse' required key='warehouse' note='Warehouse used for shipments'>
                <SelectDropdown
                    options={warehouseOptionsList}
                    value={selectedWarehouse}
                    onChange={v => onWarehouseSelect(v as IOption)}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default BergenCredentials;
